module.exports = __webpack_public_path__ + "static/p1-3c79bcfe6af9afe7056f6e5856276372.jpg";